/* istanbul ignore file */
/* ignored due to prior App.test coverage being deleted due to low value while needing to retain test coverage */
import React from 'react'
import { Router } from 'react-router-dom'

import { HostServices } from '@ally/federated-types'
import { MetronomeProvider, muiBankTheme } from '@ally/metronome-ui'
import ErrorBoundary from '@ally/next-remote-error-boundary'

import Login from './Login'
import { HostServicesContext } from './HostServices'

interface AppProps {
  services: HostServices
}
const App: React.FC<AppProps> = ({ services }) => {
  const name = 'login'
  const { browserHistory } = services
  return (
    <Router history={browserHistory}>
      <MetronomeProvider theme={muiBankTheme}>
        <HostServicesContext.Provider value={services}>
          <ErrorBoundary hostServices={services} name={name}>
            <Login />
          </ErrorBoundary>
        </HostServicesContext.Provider>
      </MetronomeProvider>
    </Router>
  )
}

export default App
